import { RouteConfig } from "@abaco/web-common/src/app";

const routes: RouteConfig[] = [
  {
    name: "cruscotto-logging-home",
    path: "/cruscotto-logging",
    component: () => import("./components/CruscottoLoggingApplicativoContainer.vue"),
    meta: {
      navbarItems: [
        { component: "farm-select-nav-bar-item", props: { isRequired: false } },
        { component: "campaign-select-nav-bar-item", props: { isRequired: false } },
      ],
    },
  },
  {
      name: "example-1",
      path: "/example/1",
      // component: () => import("./components/ExampleSingleTileSet.vue"),
      component: () => import("./components/CruscottoLoggingApplicativoContainer.vue"),
      props: { tileId: "example-tile1" },
      meta: {
      navbarItems: [
        { component: "farm-select-nav-bar-item", props: { isRequired: false } },
        { component: "campaign-select-nav-bar-item", props: { isRequired: false } },
      ],
    },
  },
  {
      name: "example-2",
      path: "/example/2",
      // component: () => import("./components/ExampleSingleTileSet.vue"),
      component: () => import("./components/CruscottoLoggingApplicativoContainer.vue"),
      props: { tileId: "example-tile2" },
      meta: {
      navbarItems: [
        { component: "farm-select-nav-bar-item", props: { isRequired: false } },
        { component: "campaign-select-nav-bar-item", props: { isRequired: false } },
      ],
    },
  }
];

export default routes;
